import React, { useState } from "react";

function PaloAltoShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Comprehensive Junk Removal in Palo Alto, CA</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="resid-rmv">
          <span>Residential Junk Removal:</span>&nbsp;Clear out old furniture,
          mattresses, old appliances, and more with our efficient same-day
          service.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <p>
              <span>Commercial Junk Removal:</span>&nbsp;Office cleanouts,
              office furniture removal, and warehouse cleanups for small
              businesses and commercial properties. <br />
              <span>Construction Debris Removal:</span>&nbsp;Fast cleanup for
              construction sites, including scrap metal, building materials, and
              yard debris.
              <br />
              <span>Heavy Lifting:</span>&nbsp;We handle large items like
              exercise equipment, hot tubs, and oversized furniture.
              <br />
              <span>Hot Tub Removal:</span>&nbsp;Safe and efficient removal of
              old hot tubs.
              <br />
              <span>Mattress Removal:</span>&nbsp;Eco-friendly disposal of old
              mattresses.
              <br />
              <span>Yard Waste Removal:</span>&nbsp;Clear out branches, leaves,
              grass, and other yard debris.
              <br />
              <span>Furniture Removal:</span>&nbsp;Haul away couches, chairs,
              tables, cabinets, and more.
              <br />
              <span>Appliance Removal:</span>&nbsp;Eco-friendly disposal of
              appliances.
              <br />
              <span>E-Waste Recycling:</span>&nbsp;Safely dispose of electronic
              waste like computers, printers, and other tech equipment.
              <br />
              <span>Trash Removal:</span>&nbsp;Get rid of unwanted junk and
              trash to free up space in your home or office.
              <br />
              <span>Junk Hauling:</span>&nbsp;We haul away all types of items,
              big or small.
              <br />
              <span>Garage Cleanouts:</span>&nbsp;Clear out clutter from your
              garage with our full-service junk removal.
              <br />
              <span>Storage Unit Cleanouts:</span>&nbsp;We help you declutter
              storage units efficiently.
              <br />
              <span>Estate Cleanouts:</span>&nbsp;Compassionate and thorough
              cleanout services for estates.
              <br />
              <span>Basement Cleanouts:</span>&nbsp;Transform your basement with
              our expert cleanout services.
            </p>
          </div>

          <h3>Serving Palo Alto, CA, and Surrounding Areas</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <p className="santa-junk-sec">
            Our junk removal services cover Palo Alto, California, and nearby
            communities, including Menlo Park, Mountain View. Whether you’re
            tackling a home cleanout, managing a commercial property, or
            cleaning up a construction site, we’re here to provide reliable and
            affordable junk removal in the Palo Alto area.
          </p>
          <h3>Contact Junk Droid for Junk Removal in Palo Alto, CA</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              Ready to clear out your unwanted junk? Call Junk Droid today for a
              free estimate! Whether it’s old furniture, appliances,
              construction debris, or large items, we’re your trusted junk
              removal expert in Palo Alto, CA. Book your same-day service now
              and reclaim your space!
              <br />
              <span>Call Now for a Free Estimate:</span>&nbsp;{" "}
              <a href="tel:+4085397261">(408) 539-7261</a> <br />
              <span>Book Online Today:</span>&nbsp;{" "}
              <a href="https://online-booking.workiz.com/?ac=2f3063010df7315df866536f0fa1a1f46be816ae2841d0100103eb5b69cf328f">
                Book Online
              </a>
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default PaloAltoShowHide;
